import React from 'react'
import usePropertyQuery from '../../../hooks/use-property-query'
import UpcomingCard from '../../cards/upcoming'
import { Link } from "../../../../plugins/gatsby-plugin-atollon"
import { graphql } from 'gatsby'
import SearchForm from '../../property-search'
import sal from 'sal.js'
import moment from 'moment'

const UpcomingArchive = ({ upcomingType }) => {

  // Data
  let properties = usePropertyQuery()
  properties = {
    'inspection': properties.filter(property => property.inspections.length > 0),
    'auction': properties.filter(property => property.hasAuction && property.for === 'sale')
  }[upcomingType]

  if ( upcomingType === 'inspection' ) {
    properties = properties.map(property => {
      const inspections = property.inspections.filter(inspection => moment(inspection.startDateTimeUtc).isAfter(moment()))
      return {
        ...property,
        inspections
      }
    }).filter(property => property.inspections.length > 0)
  }
  if ( upcomingType === 'auction' ) {
    properties = properties.filter(property => moment(property.auctionDateTime).isAfter(moment()))
  }

  // State
  const [list, setList] = React.useState(properties)
  const [limit, setLimit] = React.useState(12)

  let suburbs = []
  properties?.forEach((el, i) => {
    suburbs.push(el.addressComponents[0].city)
  })
  suburbs = suburbs.filter((v, i, a) => a.indexOf(v) === i)
  suburbs.sort()

  // Ref
  const load = React.createRef()

  // Events
  let timeout = null
  const onScroll = () => {
    const position = load.current?.getBoundingClientRect()
    if (!position) return
    if (position.top >= 0 && position.bottom <= window.innerHeight) {
      if (!timeout) {
        //if (!this.timeout && this.state.length < this.state.list) {
        timeout = setTimeout(() => {
          setLimit(limit + 6)
          timeout = null
        }, 10)
      }
    } else {
      clearTimeout(timeout)
    }
  }

  // Update
  React.useEffect(() => {
    sal()
    window.addEventListener('scroll', onScroll)
    return () => {
      window.removeEventListener('scroll', onScroll)
    }
  }, [load])

  return (
    <>
      <section className='property-archive property-archive--property property-archive--upcoming'>
        <div className='property-archive__inner'>
          <div className='property-archive__header'>
            <h1>Property</h1>
          </div>
          <div className='property-archive__content'>
            <div className='property-archive__count'>
              <p>{ list?.length } listings</p>
            </div> 
            <div className='property-archive__menu'>
              <ul>
                <li><Link to='/for-sale/'>Sale</Link></li>
                <li><Link to='/sold/'>Sold</Link></li>
                <li><Link to='/upcoming-inspections/' className={upcomingType === 'inspection' ? 'active' : ''}>Inspections</Link></li>
                <li><Link to='/upcoming-auctions/' className={upcomingType === 'auction' ? 'active' : ''}>Auctions</Link></li>
              </ul>
            </div>
            <div className='property-archive__filter'>   
              <SearchForm
                list={properties || []} 
                set={setList} 
                suburbs={suburbs}
              />
            </div>
          </div>
          <div className='property-archive__items'>
            { list?.slice(0, limit).map((el) => {
              return <UpcomingCard key={ el.id } type={ upcomingType } { ...el } />
            }) }
            { list?.length === 0 && <p className='properties__no-results'>No listings at this time.</p> }
          </div>
          <div ref={ load }/>
        </div>
      </section>
    </>
  )
}

export default UpcomingArchive

export const query = graphql`
  fragment UpcomingArchiveProps on DatoCmsUpcomingArchive {
    ... on DatoCmsUpcomingArchive {
      upcomingType
    }
  }
`